import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import JBImage from 'components/essentials/JBImage';
import arQuicklookIcon from 'assets/icons/ar-quicklook.svg';
const PDPView3DButtonUI = t0 => {
  const $ = _c(6);
  const {
    url
  } = t0;
  const PDPView3DButtonUIRef = useRef(null);
  if (!url) {
    return null;
  }
  let t1;
  if ($[0] !== url) {
    t1 = () => {
      avo.ctaClicked({
        text: "View in 3D",
        targetUrl: url,
        cta: avo.Cta._3D_VIEWER,
        location: avo.Location.PDP,
        component: avo.Component.PRODUCT_CARD
      });
    };
    $[0] = url;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <JBImage src={arQuicklookIcon} width={22} height={22} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== url) {
    t3 = <div className="relative items-center bg-white border border-solid border-gray-light7 rounded-[40px] text-white flex justify-center h-10 w-10 hover:cursor-pointer" data-tip="PDPView3DButtonUI__ARtip" data-for="PDPView3DButtonUITooltipId" ref={PDPView3DButtonUIRef}><a id="PDPView3DButtonUI-link" className="h-[22px]" href={url} onClick={t1}>{t2}</a></div>;
    $[3] = t1;
    $[4] = url;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
PDPView3DButtonUI.propTypes = {
  url: PropTypes.string
};
export default PDPView3DButtonUI;